'use es6';

import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const IndexAlertsSlot = ({
  children
}) => {
  if (children) {
    return /*#__PURE__*/_jsx("div", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx("div", {});
};
IndexAlertsSlot.propTypes = {
  children: PropTypes.any
};
export default IndexAlertsSlot;